/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListItemPatientChatActivityEmpty_Patient = {
    readonly firstname: string | null;
    readonly lastname: string | null;
    readonly " $fragmentRefs": FragmentRefs<"AvatarNode_Node">;
    readonly " $refType": "ListItemPatientChatActivityEmpty_Patient";
};
export type ListItemPatientChatActivityEmpty_Patient$data = ListItemPatientChatActivityEmpty_Patient;
export type ListItemPatientChatActivityEmpty_Patient$key = {
    readonly " $data"?: ListItemPatientChatActivityEmpty_Patient$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListItemPatientChatActivityEmpty_Patient">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemPatientChatActivityEmpty_Patient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastname",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarNode_Node"
    }
  ],
  "type": "Patient",
  "abstractKey": null
};
(node as any).hash = 'f63093cd448387f82a21a6441d939356';
export default node;
